export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const APP_URL = process.env.PUBLIC_URL;
export const DEV_MODE = process.env.NODE_ENV !== 'production';
